module.exports = __webpack_public_path__ + "h5/img/close.4fffee44.gif";